import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Category } from '@mas-flow/types';
import * as categoriesApi from '../api/categories';

export const CATEGORIES_KEY = ['categories'] as const;

export function useCategories() {
  return useQuery({
    queryKey: CATEGORIES_KEY,
    queryFn: () => categoriesApi.list(),
    staleTime: 5 * 60_000,
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; color: string }) => categoriesApi.create(body),
    onSuccess: (created) => {
      qc.setQueryData<Category[]>(CATEGORIES_KEY, (prev) => prev ? [...prev, created] : [created]);
    },
  });
}

export function usePatchCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch, etag }: { id: string; patch: { name?: string; color?: string; archived?: boolean }; etag: string }) =>
      categoriesApi.patch(id, patch, etag),
    onSuccess: (updated) => {
      qc.setQueryData<Category[]>(CATEGORIES_KEY, (prev) =>
        prev ? prev.map((c) => (c.id === updated.id ? updated : c)) : prev,
      );
    },
  });
}
